/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PinterestPinIcon_viewer = {|
  +socialNetworks: ?$ReadOnlyArray<?{|
    +serviceId: ?string;
    +parameters: ?{|
      +clientId: ?string;
    |};
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PinterestPinIcon_viewer",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "socialNetworkNames",
          "value": "PINTEREST",
          "type": "[SocialNetworkNames]"
        }
      ],
      "concreteType": "SocialNetwork",
      "name": "socialNetworks",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "SocialNetworkParameters",
          "name": "parameters",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "clientId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "socialNetworks{\"socialNetworkNames\":\"PINTEREST\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/__generated__/PinterestPinIcon_viewer.graphql.js